// extracted by css-extract-rspack-plugin
export default {"copilotDisclosure":"CopilotDisclosure-module__copilotDisclosure__r2l8n","copilotDisclosureText":"CopilotDisclosure-module__copilotDisclosureText__bj14N"};